 <template>
  <div class="cpt-rich-text-toolbar">
    <slot></slot>

    <!-- 表情 -->
    <div
      v-if="config.emoji"
      v-tooltip="{ text: '表情包' }"
      class="tools-item"
      @click.stop="handleShowEmoji"
      @mouseenter="$emit('emoji-mouse-enter', $event, showEmojiContainer)"
      @mouseleave="$emit('emoji-mouse-leave', $event, showEmojiContainer)"
      :class="{'selected': showEmojiContainer}"
    >
      <i class="iconfont icon-emoji"></i>
    </div>
    
    <!-- 添加超链接 -->
    <div
      v-if="config.link"
      v-tooltip="{ text: '添加超链接' }"
      class="tools-item"
      @click.stop="handleLink"
      :class="{'selected': showLink}"
    >
      <i class="iconfont icon-link"></i>
    </div>

    <!-- 开黑卡片/开黑邀约 -->
    <div
      class="tools-item team-invite menus-item"
      @mouseenter="showTeamInviteMenu = true"
      @mouseleave="showTeamInviteMenu = false"
      @click.stop="handleTeamInvite"
      v-if="config.teamFight || config.teamInvite"
    >
      <i class="iconfont icon-fight"></i>
      <i class="iconfont arrow-direction" :class="showTeamInviteMenu ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
      <div class="tools-item-menus" v-if="showTeamInviteMenu">
        <div
          v-if="config.teamFight"
          class="tools-item-menu premades"
          @mouseenter="showFightCardMenu = true"
          @mouseleave="fightCardMenuMouseLeave"
          @click.stop
        >
          <div class="item-desc">
            <i class="iconfont icon-idcard"></i>
            <span>开黑名片</span>
          </div>
          <i class="iconfont icon-arrow-left"></i>
        </div>
        <div
          class="tools-item-menu" 
          @click.stop="handleTeamInvite"
          v-if="config.teamInvite"
        >
          <i class="iconfont icon-fight"></i>
          <span>开黑邀约</span>
        </div>
      </div>

      <fightCardMenu 
        ref="fightCardMenuRef" 
        v-if="showFightCardMenu" 
        :list="user_card_setting.cards"
        :isShow="{ teamFight: config.teamFight, teamInvite: config.teamInvite, teamIdCard: config.teamIdCard }"
        @fightCardMenuMouseEnterEmit="fightCardMenuMouseEnterEmit"
        @fightCardMenuMouseLeaveEmit="fightCardMenuMouseLeaveEmit"
        @refresh="getUserCardSetting"
      ></fightCardMenu>
    </div>

    <!-- 开黑名片 -->
    <div
      v-if="config.teamIdCard"
      @mouseenter="showTeamIdCardMenu = true"
      class="tools-item"
      @click="handleShowTeamCard"
    >
      <i class="iconfont icon-idcard"></i>

      <fightCardMenu 
        ref="fightCardMenuRef" 
        v-if="showTeamIdCardMenu" 
        :list="user_card_setting.cards"
        :isShow="{ teamFight: config.teamFight, teamInvite: config.teamInvite, teamIdCard: config.teamIdCard }"
        @fightCardMenuMouseEnterEmit="fightCardMenuMouseEnterEmit"
        @fightCardMenuMouseLeaveEmit="fightCardMenuMouseLeaveEmit"
        @refresh="getUserCardSetting"
      ></fightCardMenu>
    </div>

    <!-- 截图 -->
    <div
      v-if="config.screenShot"
      v-tooltip="{ text: `截图${ calcScreenShotKeys }<br/>按住 Shift 点截图可隐藏黑盒窗口` }"
      class="tools-item"
      @click="handleScreenShot"
    >
      <i class="iconfont icon-capture"></i>
    </div>

    <!-- 上传文件 -->
    <div
      v-if="config.file"
      v-tooltip="{ text: '上传文件' }"
      class="tools-item"
    >
      <i class="iconfont icon-file"></i>
      <input
        type="file"
        :id="'IM-file' + _uid"
        name="file"
        accept="*"
        @click="reportIconClick('file')"
        @change="handleFileUpload"
        @keydown.enter.prevent
      />
    </div>

    <!-- 仅上传图片 -->
    <div
      v-if="config.image"
      v-tooltip="{ text: canSendImage ? '上传图片' : '暂无权限在此频道发送图片' }"
      class="tools-item"
      :class="{ 'disabled': !canSendImage }"
    >
      <i class="iconfont icon-pic"></i>
      <input
        type="file"
        name="file"
        :disabled="!canSendImage"
        :accept="imgToolAccept"
        @click="reportIconClick('image')"
        @change.stop.prevent="handleImageUpload"
        @keydown.enter.prevent
      />
    </div>

    <!-- 上传图片/视频 -->
    <div
      v-if="config.imgVideoGroup"
      v-tooltip="{ text: canSendImage ? '上传图片/视频' : '暂无权限在此频道发送图片/视频' }"
      class="tools-item"
      :class="{ 'disabled': !canSendImage }"
    >
      <i class="iconfont icon-pic"></i>
      <input
        type="file"
        name="file"
        :disabled="!canSendImage"
        :accept="imgVideoToolAccept"
        @click="reportIconClick('img_video_group')"
        @change.stop.prevent="handleImageUpload"
        @keydown.enter.prevent
      />
    </div>

    <!-- 使用机器人 -->
    <div
      v-if="config.botCommand"
      v-tooltip="{ text: '使用机器人' }"
      class="tools-item"
      :class="{'selected': showBotCmdPanel}"
      @click.stop="handleBotCommandClick"
    >
      <i class="iconfont icon-bot"></i>
    </div>

    <!-- 创建投票 -->
    <div
      v-if="config.vote"
      v-tooltip="{ text: '创建投票' }"
      class="tools-item"
      @click.stop="handleCreateVoteClick"
    >
      <i class="iconfont icon-vote-bold"></i>
    </div>

    <!-- 菜单 -->
    <div
      v-if="config.menus && config.menus.length"
      class="tools-item menus-item"
      @click.stop="handleShowMenus(true)"
      @mouseenter="handleMenuMouseEnter"
      @mouseleave="handleMenuMouseLeave"
      :class="{'selected': showMenu}"
    >
      <i class="iconfont" :class="config.menusIcon || 'icon-add-circle'"></i>
      <div class="tools-item-menus" v-show="showMenu">
        <div
          class="tools-item-menu"
          v-for="menu in config.menus"
          :key="menu.type"
          @click.stop="handleMenuClick(menu.type)"
        >
          <i v-if="menu.icon" class="iconfont" :class="menu.icon"></i>
          <span>{{ menu.text }}</span>
          <input
            v-if="menu.type === 'file'"
            type="file"
            :id="'IM-file' + _uid"
            name="file"
            accept="*"
            @change="handleFileUpload"
            @keydown.enter.prevent
          />
          <input
            v-else-if="menu.type === 'image'"
            type="file"
            name="file"
            :disabled="!canSendImage"
            :accept="imgToolAccept"
            @change.stop.prevent="handleImageUpload"
            @keydown.enter.prevent
          />
          <input
            v-else-if="menu.type === 'imgVideoGroup'"
            type="file"
            name="file"
            :disabled="!canSendImage"
            :accept="imgVideoToolAccept"
            @change.stop.prevent="handleImageUpload"
            @keydown.enter.prevent
          />
        </div>
      </div>
    </div>
    
    <!-- 展开输入框 -->
    <div
      v-if="config.expand"
      v-tooltip="{ text: '展开' }"
      class="tools-item"
      @click.stop="handleExpandInput"
    >
      <i class="iconfont icon-expand-bold"></i>
    </div>

    <!-- 全屏输入 -->
    <div
      v-if="config.fullScreen"
      v-tooltip="{ text: '全屏输入' }"
      class="tools-item"
      @click.stop="handleFullScreen"
    >
      <i class="iconfont icon-expand-bold"></i>
    </div>

    <!-- 退出全屏 -->
    <div
      v-if="config.exitFullScreen"
      v-tooltip="{ text: '退出全屏' }"
      class="tools-item"
      @click.stop="handleFullScreen"
    >
      <i class="iconfont icon-reduce-bold"></i>
    </div>

    <div
      v-if="config.bold"
      class="tools-item"
      :class="{'selected': selected.bold}"
      @click.stop="handleBoldTextClick"
    >
      <i class="iconfont icon-bold-bold"></i>
    </div>
    <div
      v-if="config.italic"
      class="tools-item"
      :class="{'selected': selected.italic}"
      @click.stop="handleItalicTextClick"
    >
      <i class="iconfont icon-italic-bold"></i>
    </div>
    <Button
      v-if="config.cancel"
      class="submit-button cancel-button"
      type="cancel"
      text="取消"
      @click.native.stop="handleCancel"
    />

    <!-- 发送 -->
    <template v-if="config.submit">
      <div
        v-if="config.timing"
        class="submit-timing-button flex-center h-[30px] min-w-[64px] bg-bd-fl rounded-[5px] overflow-hidden"
        :class="{ 'disabled': submitInfo.disabled }"
      >
        <Button
          class="submit-button"
          :text="edit_timing_msg ? '保存' : '发送'"
          :loading="submitInfo.loading"
          @click.native.stop="handleSubmit"
        />
        <div
          class="timing-btn flex-center"
          v-if="edit_timing_msg"
          :class="{ 'disabled': submitInfo.disabledTiming }"
          @mouseenter="handleTimingMouseEnter"
          @mouseleave="handleTimingMouseLeave"
        >
          <i class="iconfont icon-arrow-down"></i>
        </div>
        <div
          v-else
          class="timing-btn flex-center"
          :class="{ 'disabled': submitInfo.disabledTiming }"
          v-tooltip="{ text: submitInfo.disabledTiming ? `最多发送${max_timing_msg_count}条定时消息` : '定时发送' }"
          @click="handleTiming"
        >
          <i class="iconfont icon-arrow-down"></i>
        </div>
      </div>
      <Button
        v-else
        class="submit-button"
        :class="{ 'disabled': submitInfo.disabled }"
        text="发送"
        :loading="submitInfo.loading"
        @click.native.stop="handleSubmit"
      />
    </template>
  </div>
</template>

<script>
import { DEFAULT_RICH_TEXT_CONFIG, INPUT_ACCEPT_IMGAGE, INPUT_ACCEPT_VIDEO} from '_lib/constants/richInput'
import { reportData } from '_api/report'
import EventBus from '_lib/EventBus'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mouse_key_map } from '_js/keyMouseCode'
import fightCardMenu from "_com/busy/UserCard/components/fightCardMenu.vue"
import { getUserCardSetting } from '_api/account'

export default {
  props: {
    group: {
      type: String,
      default: ''
    },
    selected: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: DEFAULT_RICH_TEXT_CONFIG
    },
    submitInfo: {
      type: Object,
      default: () => ({
        loading: false,
        disabled: false
      })
    },
    showBotCmdPanel: {
      type: Boolean,
      default: false
    },
    needReportClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showEmojiContainer: false,
      showLink: false,
      showMenu: false,
      showTeamInviteMenu: false,
      showFightCardMenu: false,
      showLaughterContainer: false,
      showTeamIdCardMenu: false,
      imgToolAccept: INPUT_ACCEPT_IMGAGE,
      imgVideoToolAccept: INPUT_ACCEPT_IMGAGE + ',' + INPUT_ACCEPT_VIDEO,
      _menuHoverTimer: null
    }
  },
  computed: {
    calcScreenShotKeys() {
      if (!this.setting_data.screenshot_key) return ''
      let keys = this.setting_data.screenshot_key.map(id => mouse_key_map[id]).join('+')
      return `(${keys})`
    },
    canSendImage() {
      if(this.group !== 'im') return true
      return !!this.$permission.judge('SendImage', this.channel_data.channel_id)
    },
    ...mapGetters(['cur_room_data', 'channel_data', 'setting_data', 'user_card_setting', 'edit_timing_msg', 'max_timing_msg_count'])
  },
  mounted () {
    EventBus.$on('Hide_Emoji_Selector', this.onEmojiSelectorHide)
    EventBus.$on('Hide_Laughter_Selector', this.handleHideLaughterSelector)
    
    this.getUserCardSetting()
  },
  beforeDestroy () {
    EventBus.$off('Hide_Emoji_Selector', this.onEmojiSelectorHide)
    EventBus.$off('Hide_Laughter_Selector', this.handleHideLaughterSelector);
    if (this.showEmojiContainer) {
      this.onEmojiSelectorHide(this.config.emojiCaller)
    }
    window.removeEventListener('click', this.handleHideMenus)
    clearTimeout(this._menuHoverTimer)
  },
  methods: {
    onEmojiSelectorHide (type) {
      if (type === this.config.emojiCaller) {
        this.showEmojiContainer = false
        EventBus.$emit('Show_Emoji_Selector', false)
        this.$emit('emojiClose')
      }
    },
    handleShowMenus (isClick = false) {
      if (this.config.menusTrigger === 'hover') return
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        window.addEventListener('click', this.handleHideMenus)
      } else {
        window.removeEventListener('click', this.handleHideMenus)
      }
      // 是点击才触发上报
      if (isClick) {
        this.reportIconClick('menus')
      }
    },
    handleMenuMouseEnter () {
      if (this.config.menusTrigger !== 'hover') return
      clearTimeout(this._menuHoverTimer)
      clearTimeout(this._menuHoverShowTimer)
      this._menuHoverShowTimer = setTimeout(() => {
        this.showMenu = true
      }, 50)
    },
    handleMenuMouseLeave () {
      if (this.config.menusTrigger !== 'hover') return
      clearTimeout(this._menuHoverTimer)
      clearTimeout(this._menuHoverShowTimer)
      this._menuHoverTimer = setTimeout(() => {
        this.showMenu = false
      }, 100)
    },
    handleMenuClick (type) {
      this.$emit('tool-click', type)
      if (type !== 'file' && this.showMenu) {
        this.handleShowMenus()
      }
    },
    handleHideMenus () {
      this.showMenu = false
      window.removeEventListener('click', this.handleHideMenus)
    },
    handleScreenShot (e) {
      this.$emit('tool-click', 'screenShot', e)
      this.reportIconClick('screen_shot')
    },
    handleShowEmoji(e) {
      this.$emit('tool-click', 'emoji', e)
      e.stopPropagation()
      if(!this.showEmojiContainer) {
        let pos = e.target.getBoundingClientRect()
        pos.x += this.config.emojiXOffset || 100
        EventBus.$emit('Show_Emoji_Selector', true, pos, this.config.emojiCaller, this.insertEmoji)
      } else {
        EventBus.$emit('Show_Emoji_Selector', false)
      }
      this.$emit('update-recent-emoji', false)
      this.showEmojiContainer = !this.showEmojiContainer

      this.reportIconClick('emoji')
    },
    insertEmoji (group_type, item, size) {
      const img_info = {
        ...item,
        group_type,
        size
      }
      this.showEmojiContainer = false
      this.$emit('chooseEmoji', img_info)
    },
    handleLink (e) {
      EventBus.$emit('HandleRichToolBar', {
        group: this.group,
        type: 'link',
        data: {
          event: e
        },
        cb: () => {
          this.showLink = false
        }
      })
      this.showLink = true

      this.reportIconClick('link')
    },
    handleImageUpload(e) {
      if(!this.canSendImage) return
      const file = e.target.files[0];
      const fileType = file.type;

      if (fileType.startsWith("video/")) {
        if (this.group === 'im') {
          EventBus.$emit('Im_Upload_File', e)
        } else if (this.group === 'private_im') {
          EventBus.$emit("Private_Im_Upload_File", e)
        } else if (this.group === 'group-im') {
          EventBus.$emit("Group_Im_Upload_File", e)
        }
      } else if (fileType.startsWith("image/")) {
        this.$emit('tool-click', 'image', e)
        if (this.config.imageInMarkdown) {
          EventBus.$emit('HandleRichToolBar', {
            group: this.group,
            type: 'image',
            data: {
              event: e
            }
          })
        } else {
          this.uploadImageToIm(e)
        }
      }
      setTimeout(() => {
        e.target.value = ''
      }, 100)
    },
    handleFileUpload (e) {
      this.$emit('tool-click', 'file', e)
      const file = e.target?.files[0];
      if (!file) {
        this.$toast.error('文件上传失败，请稍后重试')
      }
      if (file.type?.startsWith('image/')) {
        if (this.config.image && this.config.imageInMarkdown) {
          this.handleImageUpload(e)
        } else {
          this.uploadImageToIm(e)
        }
      } else {
        EventBus.$emit('Im_Upload_File', e, () => {
          e.target.value = ''
        })
      }
      if (this.showMenu) {
        this.handleShowMenus()
      }
    },
    uploadImageToIm (e) {
      if (this.group === 'im') {
        EventBus.$emit('Im_Upload_Img', e)
      } else if (this.group === 'private_im') {
        EventBus.$emit('Private_Im_Upload_Img', e)
      } else if (this.group === 'group-im') {
        EventBus.$emit('Group_Im_Upload_Img', e)
      } else if (this.group === 'global_team_im') {
        EventBus.$emit('Global_Team_Im_Upload_Img', e)
      }
    },
    handleTeamInvite(e) {
      if (!this.config.teamInvite) return;
      this.$emit('tool-click', 'teamInvite', e)
      reportData('team_invite:click', {
        room_id: this.cur_room_data.room_id,
        channel_id: this.channel_data.channel_id,
      })
      EventBus.$emit('team-invite', { mode: 'create' })
      this.reportIconClick('team_invite')
    },
    handleFullScreen(e) {
      this.$emit('tool-click', 'fullScreen', e)
      this.reportIconClick('full_screen')
    },
    handleSubmit (e) {
      if (this.submitInfo.disabled || this.submitInfo.loading) return
      this.$emit('submit', e, this.edit_timing_msg ? this.edit_timing_msg.timer_send_time : null)
    },
    handleTiming (e) {
      if (this.submitInfo.disabledTiming || this.submitInfo.disabled) return
      this.$emit('tool-click', 'timing', e)
    },
    handleTimingMouseEnter (e) {
      if (this.submitInfo.disabledTiming || this.submitInfo.disabled) return
      this.$emit('tool-click', 'timing', e, 'mouseEnter')
    },
    handleTimingMouseLeave (e) {
      this.$emit('tool-click', 'timing', e, 'mouseLeave')
    },
    handleCancel (e) {
      this.$emit('cancel', e)
    },
    fightCardMenuMouseLeave() {
      setTimeout(() => {
        if(!this.isInFightMenu) {
          this.showFightCardMenu = false
          this.showTeamIdCardMenu = false
        }
      }, 0)
    },
    fightCardMenuMouseEnterEmit() {
      this.isInFightMenu = true
      this.showFightCardMenu = true
      this.showTeamInviteMenu = true
      this.showTeamIdCardMenu = true
    },
    fightCardMenuMouseLeaveEmit() {
      this.isInFightMenu = false
      this.showFightCardMenu = false
      this.showTeamIdCardMenu = false
    },
    getUserCardSetting() {
      // INFO: IM或全局组队IM状态才请求卡片数据
      if (['im', 'global_team_im'].includes(this.group)) {
        getUserCardSetting().then(res => {
          if(res.data.status === 'ok') {
            this.SET_USER_CARD_SETTING(res.data.result.setting || [])
          }
        })
      }
    },
    handleShowLaughter(event) {
      const target = event.target;
      const pos = target.getBoundingClientRect();
      pos.x = pos.x - 200;
      pos.y = pos.y - 451 - 30;
      if (!this.showLaughterContainer) {
        EventBus.$emit('SHOW_LAUHGTER_SELECTOR', true, pos);
      } else {
        EventBus.$emit('SHOW_LAUHGTER_SELECTOR', false);
      }
      this.showLaughterContainer = !this.showLaughterContainer;
    },
    handleHideLaughterSelector() {
      this.showLaughterContainer = false
    },
    handleExpandInput(e) {
      this.SET_SHOW_AUDIO_IM_ACTION(true)
      this.SET_CUR_CHANNEL_NEW_MSG_COUNT(0)
      this.reportIconClick('expand')
    },
    handleShowTeamCard() {
      this.showFightCardMenu = true
      this.reportIconClick('team_id_card')
    },
    handleBotCommandClick(event) {
      this.$emit('tool-click', 'botCommand', event)
      this.reportIconClick('bot_command')
    },
    handleCreateVoteClick(event) {
      this.$emit('tool-click', 'createVote', event)
      this.reportIconClick('create_vote')
    },
    handleBoldTextClick(event) {
      this.$emit('tool-click', 'bold', event)
      this.reportIconClick('bold')
    },
    handleItalicTextClick(event) {
      this.$emit('tool-click', 'italic', event)
      this.reportIconClick('italic')
    },
    reportIconClick(type) {
      if (!this.needReportClick) return;
      reportData(`simple_rich_text_toolbar_icon:click`, {
        type,
      })
    },
    ...mapMutations([
      'SET_USER_CARD_SETTING',
      'SET_CUR_CHANNEL_NEW_MSG_COUNT'
    ]),
    ...mapActions(['SET_SHOW_AUDIO_IM_ACTION'])
  },
  components: {
    fightCardMenu
  }
}
</script>

<style lang="scss">
.cpt-rich-text-toolbar {
  position: absolute;
  bottom: 20px;
  right: 24px;
  display: flex;
  align-items: center;
  .tools-item {
    height: 28px;
    width: 28px;
    padding: 4px;
    margin-right: 4px;
    position: relative;
    cursor: pointer;

    &.team-invite {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      position: relative;
      left: 0;
      z-index: 1000;

      .arrow-direction {
        font-size: 6px;
        margin-left: 2px;
      }

      &.menus-item {
        .tools-item-menus {
          bottom: 100%; 
          .tools-item-menu {
            &.premades {
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              left: 0;
              top: 0;

              .item-desc{
                display: flex;
              }

              .icon-arrow-left {
                font-size: 6px;
              }
            }
          }
        }
      }
    }

    &:last-child {
      margin-right: 0;
    }
    & > i {
      font-size: 20px;
      color: $d-op-4;
      cursor: pointer;
    }

    &:hover, &.selected {
      background-color: $d-op-2;
      border-radius: 3px;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: .4;
      & > i, & > input {
        cursor: not-allowed;
      }
    }
    &.menus-item {
      position: relative;
      .tools-item-menus {
        position: absolute;
        bottom: calc(100% + 11px);
        left: 50%;
        transform: translateX(-50%);
        padding: 8px;
        border-radius: 8px;
        background: $d-fl-pp;
        box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
        z-index: 999;
        .tools-item-menu {
          display: flex;
          align-items: center;
          width: 172px;
          height: 32px;
          padding: 0 8px;
          border-radius: 5px;
          cursor: pointer;
          color: $d-tx-2;
          position: relative;
          &:hover {
            background: $d-bd-fl;
            color: $ct-wh-0;
          }
          .iconfont {
            font-size: 16px;
            margin-right: 4px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
          }
        }
        
      }
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      cursor: pointer;
      font-size: 0;
    }
  }
  .submit-button {
    width: auto;
    height: 32px;
    padding: 0 18px;
    font-size: 14px;
    line-height: 18px;
    &.cancel-button {
      margin-right: 8px;
    }
  }
  .submit-timing-button {
    position: relative;
    &:not(.disabled):hover::before {
      display: none;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: .4;
      .submit-button, .timing-btn {
        cursor: not-allowed;
        &:hover {
          background-color: transparent;
        }
      }
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 20px;
      width: 1px;
      background-color: $ct-wh-2;
    }
    .submit-button {
      padding: 0 10px;
      border-radius: 5px 0 0 5px;
      background-color: transparent;
      &:hover {
        background-color: $d-op-2;
      }
    }
    .timing-btn {
      width: 21px;
      height: 100%;
      cursor: pointer;
      border-radius: 0 5px 5px 0;
      &:hover {
        background-color: $d-op-2;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .icon-arrow-down {
      width: 6px;
      height: 6px;
      transition: transform 0.15s;
      color: $ct-wh-0;
      &.rotate {
        transform: rotate(180deg);
      }
      &::before {
        font-size: 12px;
        width: 12px;
        height: 12px;
        transform: scale(0.5);
        transform-origin: left top;
      }
    }
  }
}
</style>